import { FlowStandardAnalyticEventCategoryStatus } from 'flow-schema';
import { z } from 'zod';

export {
  type FlowStandardAnalyticEventCategoryBody,
  FlowStandardAnalyticEventCategoryBodySchema,
  type FlowStandardAnalyticEventCategoryListQuery,
  FlowStandardAnalyticEventCategoryListQuerySchema,
  FlowStandardAnalyticEventCategoryStatus,
} from 'flow-schema';

export const StandardAnalyticEventCategorySchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  status: z.enum(FlowStandardAnalyticEventCategoryStatus),
  created: z.string().date(),
  updated: z.string().date(),
});

export type StandardAnalyticEventCategory = z.infer<typeof StandardAnalyticEventCategorySchema>;
